export default {
  primary: {
    base: '#56544d',
    darken1: '#000000',
    lighten1: '#dad7cf'
  },
  secondary: {
    base: '#3296f3',
    lighten1: '#36a5c4'
  },
  ice: {
    base: '#DAEDFF',
    lighten1: '#EBF5FE'
  },
  navy: {
    base: '#072846'
  },
  accent: {
    base: '#e91e63',
    lighten1: '#ff6090'
  },
  gold: {
    base: '#FFC107'
  },
  magenta: {
    base: '#e91e63'
  },
  bpurple: {
    base: '#673AB7'
  },
  // All keys will generate theme styles,
  // Here we add a custom `tertiary` color
  highlight: {
    base: '#fbc109'
  },
  backbox: {
    base: '#F5F5F5'
  },
  footer: {
    base: '#072846'
  }
}